import { useContext } from "react";
import { User } from "lucide-react";
import { SidebarContext } from "../../../shared/context/SidebarContext";
import { UsuariosContext } from "../context/UsuariosContext";
import { ContainerCreateUser, ContainerFilters, TableUsers } from ".";
import { ModalEdit } from "./modals";


export default function Main() {

    const { isOpen } = useContext(SidebarContext);
    const { isModalOpen } = useContext(UsuariosContext);


    return (
        <div className="min-h-screen text-ink-1 flex relative z-0">
            <div className={`transition-all duration-300 ease-out-expo ${isOpen ? "lg:ml-64" : "sm:ml-16"} w-full max-w-full mb-16 sm:mb-0`}>

                <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

                    <header className="mb-8 animate-fade-in">
                        <div className="space-y-1">
                            <span className="label-overline">Configuração</span>
                            <h1 className="display-2 flex items-center gap-3">
                                Usuários
                                <User className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
                            </h1>
                            <p className="text-ink-3 text-sm">
                                Acesso dos colaboradores ao painel — vincule cada usuário à empresa correspondente.
                            </p>
                        </div>
                    </header>

                    <ContainerCreateUser />
                    <ContainerFilters />
                    <TableUsers />

                </div>

                {isModalOpen && <ModalEdit />}
            </div>
        </div>
    );
}
